import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessReservationsDataService, FitnessReservationsColumnsService } from '../../../services';
import { FitnessReservation, FitnessReservationsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-fitness-reservation-details',
  templateUrl: './fitness-reservation-details.component.html',
  styleUrls: ['./fitness-reservation-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessReservationDetailsComponent implements OnInit, OnDestroy {

  public fitnessReservation: FitnessReservation = {};
  public fitnessReservations: FitnessReservation[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessReservationsDataService: FitnessReservationsDataService,
    private fitnessReservationsColumnsService: FitnessReservationsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Reservation - Details');
        this.getFitnessReservation(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessReservation !== 'undefined') {
      this.fitnessReservation = this.dynamicDialogConfig.data.fitnessReservation;
    }
    this.columns = this.fitnessReservationsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getFitnessReservation(id: number): void {
    this.isLoading = true;
    this.fitnessReservationsDataService.getFitnessReservation(id).subscribe((response: FitnessReservation|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessReservation = response;
      }
    });
  }

  list() {
    this.router.navigate(['/fitness-reservations']);
  }

  add() {
    this.router.navigate(['/fitness-reservations/add']);
  }

  edit() {
    this.router.navigate(['/fitness-reservations/edit/' + this.fitnessReservation.id]);
  }

}
@Component({
  selector: 'app-fitness-reservation-details',
  templateUrl: './fitness-reservation-details.component.html',
  styleUrls: ['./fitness-reservation-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessReservationDetailsComponent extends FitnessReservationDetailsComponent {
}

